import {API} from "@/components/_Shared/API/API"
import { ClientProps } from "@/interfaces/client_types.ts";
import {
    CREATE_CLIENT,
    DELETE_CLIENT,
    GET_CLIENT_BY_UUID,
    GET_CLIENTS,
    GET_PROJECTS_BY_CLIENT,
    UPDATE_CLIENT
} from "@/api/Endpoints/client.ts";

export function getClients() {
    return API.get<ClientProps[]>(GET_CLIENTS)
}

export function getClientById(uuid: string) {
    return API.get<ClientProps>(GET_CLIENT_BY_UUID.replace("{uuid}", uuid))
}

export function createClient(data: ClientProps) {
    return API.post<ClientProps>(CREATE_CLIENT, data)
}

export function updateClient(data: ClientProps) {
    return API.put<ClientProps>(UPDATE_CLIENT.replace("{uuid}", data.uuid), data)
}

export function deleteClient(uuid: string) {
    return API.delete(DELETE_CLIENT.replace("{uuid}", uuid))
}

export function getProjectsByClient(uuid: string) {
    return API.get<ClientProps[]>(GET_PROJECTS_BY_CLIENT.replace("{uuid}", uuid))
}